<template>
  <div class="managementComment">
    <el-card class="box-card">
      <div slot="header" class="flex-le">
        <div class="search_condition">
          <div class="flex-le">
            <div class="flex-le">
              <span style="margin-right: 5px;width: 80px">商品名称</span>
              <el-input v-model="productname" size="small"></el-input>
            </div>

            <div style="margin: 0 20px">
              商品类别
              <el-select size="small" v-model="orderStatus" placeholder="请选择" class="search_condition_item">
                <el-option
                    v-for="item in orderStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="flex-le">
              <span style="margin-right: 5px;width: 80px">用户昵称</span>
              <el-input v-model="UsersNickname" size="small"></el-input>
            </div>
<!--            <div style="margin-left: 20px">-->
<!--              下单时间-->
<!--              <el-date-picker-->
<!--                  size="small"-->
<!--                  v-model="value1"-->
<!--                  type="datetimerange"-->
<!--                  range-separator="至"-->
<!--                  start-placeholder="开始日期"-->
<!--                  end-placeholder="结束日期">-->
<!--              </el-date-picker>-->
<!--            </div>-->
          </div>
        </div>
        <div class="flex-le">
          <el-button type="primary" icon="el-icon-search" size="small" @click="getAllKb" style="margin-left: 5px;">查询结果</el-button>
        </div>
      </div>
      <div class="content_table">
        <tableTotal :index-show="configTable.indexShow" :config-data="configTable.configData"
                    :table-data="configTable.tableData" :loading="configTable.loading"></tableTotal>
        <div class="pagination_box m-t-20">
          <el-pagination
              @current-change="getData"
              @size-change="handleSizeChange"
              :current-page.sync="configTable.current"
              layout="total, sizes, prev, pager, next, jumper"
              background
              :page-sizes="[10,15,20]"
              :page-size="configTable.pageSize"
              :total="configTable.total"
          ></el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import tableTotal from "@/components/TableTotal/TableTotal";

export default {
  name: "managementComment",
  // import引入的组件需要注入到对象中才能使用
  components: {
    tableTotal
  },
  data() {
    // 这里存放数据
    return {
      UsersNickname: '',
      productname: '',
      kb_content: '',
      value1: [],
      active: 0,
      // statusList: [
      //   {value: 12, label: '全部订单'},
      //   {value: 2, label: '待付款'},
      //   {value: 1, label: '待收货'},
      //   {value: 0, label: '待评价'},
      // ],
      orderTime: 1,
      orderTimeList: [
        {value: 1, label: '全部'},
        {value: 2, label: '近半年订单'},
        {value: 3, label: '近一年订单'},
      ],
      orderStatus: 0,
      orderStatusList: [
        {value: 0, label: '全部状态'},
        {value: 1, label: '待支付'},
        {value: 2, label: '已完成'},
        {value: 3, label: '待评价'},
      ],
      // 配置表格
      configTable: {
        loading: false,
        indexShow: false,
        configData: [
          {
            type: 'selection'
          },
          {
            value: 'value',
            label: '编号',
            align: 'left'
          },
          {
            value: 'name',
            label: '用户昵称',
            align: 'left'
          }, {
            value: 'value',
            label: '商品名称',
            align: 'left'
          },{
            value: 'value',
            label: '评价',
            align: 'left'
          },
          {
            value: 'value',
            label: '评论时间',
            align: 'left'
          },
          {
            type: 'switch',
            value: 'show',
            label: '是否显示',
            align: 'left'
          },
        ],
        tableData: [],
        current: 1, // 当前页码
        total: 10, // 数据总条数
        pageSize: 10
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(11);
    this.info();
  },
  // 方法集合
  methods: {
    getAllKb() {
      console.log(this.kb_content);
    },
    info() {
      // 获取数据
      this.getData();
    },
    getData() {
      this.configTable.loading = true;
      let data = [{name: '1212312', value: 1,show: true},
        {name: '12', value: 1}];
      this.configTable.tableData = data;
      setTimeout(() => {
        this.configTable.loading = false;
      }, 1000)
    },
    handleClick(event, data, text) {
      switch (event) {
        case 'seeData':
          console.log(event, data, text);
          break
        case 'evaluation':
          console.log(event, data, text);
          break
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    changeStatus(data, index) {
      this.active = index;
    },
  },
}
</script>

<style scoped lang="scss">
.managementComment {
  .activeStyle {
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
  }

  .search_condition_item {
    width: 140px;
  }

  .pagination_box {
    text-align: right;
  }

  .flex-le {
    font-size: 14px;
  }

}
</style>
